import { render, staticRenderFns } from "./ModalGestionBarquettes.vue?vue&type=template&id=28ab4e83&"
import script from "./ModalGestionBarquettes.vue?vue&type=script&lang=js&"
export * from "./ModalGestionBarquettes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports